var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "external-content-view" },
    [
      _vm.showSearch
        ? _c("SelectFolderModalToolbar", {
            attrs: { value: _vm.searchKey },
            on: {
              input: _vm.onSearchInput,
              search: _vm.onSearchSubmit,
              clear: _vm.clearSearch,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "breadcrumb",
                  fn: function () {
                    return [_vm._t("toolbar-start")]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "external-content-view__state" },
            [_c("b-spinner")],
            1
          )
        : _vm.items.length === 0
        ? _c("div", { staticClass: "external-content-view__state" }, [
            _vm._v("\n    No items found.\n  "),
          ])
        : _c("div", { staticClass: "external-content-view__sections" }, [
            _vm.folderItems.length
              ? _c(
                  "div",
                  { staticClass: "external-content-view__section" },
                  [
                    _vm.fileItems.length
                      ? _c(
                          "div",
                          {
                            staticClass: "external-content-view__section-title",
                          },
                          [_vm._v("\n        Folders\n      ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("ItemGrid", {
                      staticClass: "folder-items",
                      attrs: {
                        items: _vm.folderItems,
                        "is-selected": _vm.isSelected,
                        columns: _vm.GRID_COLUMNS,
                        "columns-md": _vm.GRID_COLUMNS_MD,
                        "item-props": {
                          isAvailableOverlay: false,
                          showCheckbox: false,
                        },
                      },
                      on: { "item-click": _vm.onItemClick },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.fileItems.length
              ? _c(
                  "div",
                  { staticClass: "external-content-view__section" },
                  [
                    _vm.folderItems.length
                      ? _c(
                          "div",
                          {
                            staticClass: "external-content-view__section-title",
                          },
                          [_vm._v("\n        Files\n      ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("ItemGrid", {
                      attrs: {
                        items: _vm.fileItems,
                        "is-selected": _vm.isSelected,
                        columns: _vm.GRID_COLUMNS,
                        "columns-md": _vm.GRID_COLUMNS_MD,
                        "item-props": {
                          isAvailableOverlay: false,
                          showCheckbox: true,
                        },
                        "item-props-for": _vm.counterPropsFor,
                      },
                      on: {
                        "item-click": _vm.onItemClick,
                        "item-count-change": _vm.changeCount,
                        "copy-to-file-browser": (item) =>
                          _vm.$emit("copy-to-file-browser", item),
                        "open-preview": _vm.openPreview,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
      _vm._v(" "),
      _vm.lastPage > 1
        ? _c("ItemPagination", {
            attrs: {
              "total-rows": _vm.lastPage * _vm.pageSize,
              "per-page": _vm.pageSize,
            },
            on: { change: _vm.fetchItems },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("AssetPreview", {
        ref: "assetPreview",
        attrs: { item: _vm.previewItem },
        on: { "confirm-selection": _vm.onConfirmSelection },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }